import React from "react";

const PrimicModalBtn = ({ children, openModal, data, ...rest }) => (
  <a
    {...rest}
    onClick={(e) => {
      rest.onClick?.(e);
      openModal(data);
    }}
  >
    {children}
  </a>
);

export default PrimicModalBtn;
